module.exports = __webpack_public_path__ + "img/uppyError.62660ec0.svg";